import SimulationPage from '../officer/Simulation';
export default SimulationPage;
